export interface AuditLogEvent {
  id: number;
  timestamp: string; // Instant as string
  author: string;
  eventType: string;
  eventDetails: any; // JSON object
}

export enum EntityType {
  OPPORTUNITY = 'opportunity',
  LEAD = 'lead',
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
  TRUST = 'trust'
} 